import * as tslib_1 from "tslib";
import React, { useMemo } from 'react';
import { withLocalize } from 'react-localize-redux';
import _ from 'lodash';
import { useLocalize } from '../../hooks';
const ButtonComponent = (_a) => {
    var { type, translate, children } = _a, rest = tslib_1.__rest(_a, ["type", "translate", "children"]);
    const { getTranslationId } = useLocalize();
    const title = useMemo(() => {
        const text = translate(getTranslationId({ id: `btns.${type}` }));
        return _.isString(text) ? text : `[${type.toUpperCase()}]`;
    }, [translate, type]);
    const btnProps = Object.assign({ title }, _.pick(rest, ['onClick', 'tabIndex', 'className']));
    return (React.createElement("button", Object.assign({ type: "button" }, btnProps), children));
};
export const LocalizeButton = withLocalize(ButtonComponent);
//# sourceMappingURL=Button.js.map